import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate('/#contact');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleLinkClick = (path) => {
    // Force page to scroll to top when any footer link is clicked
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <img className="h-12 w-auto mb-4" src="../../public/mtclicks.png" alt="MTClicks Logo" />
            <p className="text-gray-400 mb-6 max-w-md">
              Enterprise IT solutions engineered for digital transformation. Accelerating innovation 
              through strategic technology partnerships and cutting-edge development practices.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="fab fa-linkedin text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="fab fa-github text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="fab fa-twitter text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li><button onClick={() => handleLinkClick('/cloud-architecture')} className="hover:text-white transition-colors text-left">Cloud Architecture</button></li>
              <li><button onClick={() => handleLinkClick('/application-development')} className="hover:text-white transition-colors text-left">Application Development</button></li>
              <li><button onClick={() => handleLinkClick('/devops-automation')} className="hover:text-white transition-colors text-left">DevOps & Automation</button></li>
              <li><button onClick={() => handleLinkClick('/security-compliance')} className="hover:text-white transition-colors text-left">Security & Compliance</button></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><button onClick={() => handleLinkClick('/security')} className="hover:text-white transition-colors text-left">Security</button></li>
              <li><button onClick={() => handleLinkClick('/privacy-policy')} className="hover:text-white transition-colors text-left">Privacy Policy</button></li>
              <li><button onClick={() => handleLinkClick('/terms-of-service')} className="hover:text-white transition-colors text-left">Terms of Service</button></li>
              <li><a href="#contact" onClick={handleContactClick} className="hover:text-white transition-colors cursor-pointer">Contact Us</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 MTClicks Corporation. All rights reserved. | 
            <button onClick={() => handleLinkClick('/privacy-policy')} className="hover:text-white transition-colors ml-1">Privacy Policy</button> | 
            <button onClick={() => handleLinkClick('/terms-of-service')} className="hover:text-white transition-colors ml-1">Terms of Service</button> | 
            <button onClick={() => handleLinkClick('/security')} className="hover:text-white transition-colors ml-1">Security</button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
